import { useEffect as e, useMemo as t } from "react";
//#region src/hooks/useSearchHighlight.ts
var n = "search-result-highlight", r = () => typeof window < "u" && "CSS" in window && "highlights" in CSS && typeof Highlight < "u", i = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), a = (e, t, n) => {
	let r = [];
	if (!t) return r;
	let a = new RegExp(i(t), n ? "g" : "gi"), o = document.createTreeWalker(e, NodeFilter.SHOW_TEXT), s = o.nextNode();
	for (; s;) {
		let e = s.textContent ?? "";
		a.lastIndex = 0;
		let t = a.exec(e);
		for (; t;) {
			let n = document.createRange();
			n.setStart(s, t.index), n.setEnd(s, t.index + t[0].length), r.push(n), t = a.exec(e);
		}
		s = o.nextNode();
	}
	return r;
}, o = (i) => {
	let { ref: o, query: s, highlightClassName: c = n, scopeSelector: l, caseSensitive: u = !1, deps: d } = i, f = t(() => s.trim(), [s]), p = t(() => d ?? [], [d]);
	e(() => {
		if (!r()) return;
		let e = o.current;
		if (!e) return;
		let t = CSS.highlights.get(c) ?? new Highlight();
		CSS.highlights.set(c, t);
		let n = window.requestAnimationFrame(() => {
			if (t.clear(), !f) return;
			let n = l ? e.querySelector(l) : e;
			if (n) for (let e of a(n, f, u)) t.add(e);
		});
		return () => {
			window.cancelAnimationFrame(n), t.clear();
		};
	}, [
		u,
		c,
		f,
		o,
		l,
		p
	]);
};
o.supported = () => r();
//#endregion
export { n as SEARCH_HIGHLIGHT_CLASS, o as default };

//# sourceMappingURL=useSearchHighlight.js.map